export const shabuSukiyakiTranslationJP = {
  ShabuSukiyaki: {
    title: 'しゃぶしゃぶ／すき焼き定食設定',
    description: 'どん亭専用機能です。他の業態には設定できません',
    save_button: '保存',
    save_success: '保存しました',
    shabu: 'しゃぶしゃぶ定食',
    sukiyaki: 'すき焼き定食',
    menu: 'メニュー',
    genre: 'ジャンル',
    no_genre_required: 'ジャンルは、必須選択です。',
    select_genre: 'ジャンルを選択',
    no_select: '選択無し',
    target_menu_button: '対象メニュー',
    dashi: 'だし',
  },
};
